import React, { useContext } from 'react';
import { bool, func } from 'prop-types';
import * as R from 'ramda';

// Components
import { Box } from '@mui/material';
import LocationCheckboxList from '../../components/LocationCheckboxList.connector';
import Buttons from '../../components/Buttons';
import SummaryDrawer from '../../components/SummaryDrawer';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const LastStep3 = ({ prev, next, loading }) => {
  const {
    data: { locations = [], products = [], inventoryOwners = [] },
    setData,
  } = useContext(SequencingWizardContext);
  const continueDisabled = R.isEmpty(locations);
  const handleLocations = R.o(setData, R.assoc('locations'));

  const lastInventoryOwner = `${
    inventoryOwners[inventoryOwners.length - 1]?.companyCustomerIdName
  } ${inventoryOwners[inventoryOwners.length - 1]?.nameLong}`;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 203px
          // prevents progress bar from looking off
          height: 'calc(100% - 203px)',
          // Prevents bottom selection from clipping on Y overflow
          marginBottom: '46px',
          overflowY: 'auto',
        }}
      >
        <Box flexGrow={1}>
          <LocationCheckboxList
            onChange={handleLocations}
            products={products}
            title={`Select one or more ${lastInventoryOwner} locations`}
          />
        </Box>
      </Box>
      <SummaryDrawer displayProducts inventoryOwnerSubtitle="Selected Inventory Owner" />
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={loading}
        rightLabel="Continue"
      />
    </>
  );
};

LastStep3.propTypes = {
  loading: bool.isRequired,
  next: func.isRequired,
  prev: func.isRequired,
};

export default LastStep3;
